// @flow
import * as React from 'react';
import {
    AddressFirstField,
    AddressSecondField,
    AddressThirdField,
    PostCodeField,
    CountrySelectField,
    PhoneField
} from 'app/default/field';
import Buttons from 'app/default/button';

const AddressComponent = () => (
    <form>
        <AddressFirstField />
        <AddressSecondField />
        <AddressThirdField />
        <PostCodeField />

        <CountrySelectField />
        <PhoneField />

        <Buttons back />
    </form>
);

export default AddressComponent;
